<template>
  <CCard
    :bordered="false"
    class="c-toolbar"
    :themeOverrides="{
      paddingSmall: '16px',
    }"
  >
    <slot name="left">
      <CSearch
        class="c-toolbar__search"
        :modelValue="search"
        :placeholder="placeholder ?? t('canvasUI.CSearch.search')"
        @update:model-value="emit('update:search', $event)"
      />
    </slot>
    <slot name="right"></slot>
  </CCard>
</template>

<script lang="ts">
export default {
  name: 'CToolbar',
}

interface Props {
  search?: string
  placeholder?: string
}
</script>

<script lang="ts" setup>
import CSearch from '@lib/components/CSearch/CSearch.vue'
import CCard from '@lib/components/CCard/CCard.vue'

import { useI18n } from 'vue-i18n'

const { t } = useI18n()

withDefaults(defineProps<Props>(), {})

const emit = defineEmits<{
  (e: 'update:search', value: string): void
}>()
</script>

<style lang="scss" scoped>
.c-toolbar__search {
  max-width: 400px;
}

:deep(.n-card__content) {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 16px;
}
</style>
